import React, { ReactNode } from 'react';

import { Images } from '../../../shared/app-constants';

type IProps = {
  title?: string;
  description?: ReactNode;
};

const AuthHeader: React.FC<IProps> = ({ title, description }) => (
  <div className="auth-header">
    <img
      loading="lazy"
      src={Images.TrulyInbox}
      alt="logo"
      className="auth-header--logo"
    />

    {(title || description) && (
      <div className="auth-header--content">
        {title && <h1>{title}</h1>}
        {description && <p>{description}</p>}
      </div>
    )}
  </div>
);

export default AuthHeader;
